import { BASE_URL } from "../endpoints"
import { get } from "../https"

export const getAllNotification = (): Promise<unknown> => {
    return get(localStorage.getItem('userRole') != 'super'?`${BASE_URL}/notifications`:`${BASE_URL}/super/notifications`)
  }